import type { Middleware, SerializedError } from '@reduxjs/toolkit'
import { isRejectedWithValue } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

import { getError } from '@/utils'

import toast from './toast'

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const errorMessage = getError(action.payload as FetchBaseQueryError | SerializedError)

    toast.error(errorMessage, { title: 'Algo deu errado!' })
  }

  return next(action)
}
